import React, { useEffect, useMemo, useState } from "react";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import { getLatestItems } from "../api";
import {
  capitalizeTurkish,
  getDateLocale,
  getDetailLink,
} from "../utils/utilFunction";

const getDateKey = (dateValue) => {
  if (!dateValue) return "unknown";
  const d = new Date(dateValue);
  if (Number.isNaN(d.getTime())) return "unknown";
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
};

const getAuthorLinks = (item) => {
  if (!item?.writerName) return null;
  const names = String(item.writerName)
    .split(",")
    .map((n) => n.trim())
    .filter(Boolean);
  if (!names.length) return null;

  const ids =
    item.userIdList && String(item.userIdList).trim() !== ""
      ? String(item.userIdList).split(",")
      : null;

  return names.map((name, key) => {
    const writerId = ids?.[key]?.trim() || item.userId;
    return (
      <Link
        key={`${item.id}-author-${key}`}
        to={`/yazar-detay/${writerId}/${encodeURIComponent(name)}`}
        className="latest-items__author"
      >
        {capitalizeTurkish(name)}
        {key < names.length - 1 ? ", " : ""}
      </Link>
    );
  });
};

const LatestItems = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    const load = async () => {
      setLoading(true);
      try {
        const res = await getLatestItems();
        if (!active) return;
        setItems(res?.status && Array.isArray(res.data) ? res.data : []);
      } catch {
        if (active) setItems([]);
      } finally {
        if (active) setLoading(false);
      }
    };
    load();
    return () => {
      active = false;
    };
  }, []);

  const groupedByDate = useMemo(() => {
    const groups = [];
    const map = new Map();

    for (const item of items) {
      const key = getDateKey(item.releaseDate);
      if (!map.has(key)) {
        const group = {
          key,
          label:
            key === "unknown"
              ? "Tarih bilinmiyor"
              : getDateLocale(item.releaseDate),
          items: [],
        };
        map.set(key, group);
        groups.push(group);
      }
      map.get(key).items.push(item);
    }

    return groups;
  }, [items]);

  return (
    <Container>
      <div className="page-text pt-5 mb-0 page_set">
        <h1 className="page_title">Son Eklenenler</h1>
      </div>

      <div className="latest-items">
        {loading && <p className="text-secondary">Yükleniyor...</p>}

        {!loading && groupedByDate.length === 0 && (
          <p className="text-secondary">Henüz eklenmiş madde bulunamadı.</p>
        )}

        {!loading &&
          groupedByDate.map((group) => (
            <section key={group.key} className="latest-items__group">
              <h2 className="latest-items__date">{group.label}</h2>
              <ul className="latest-items__list">
                {group.items.map((item) => {
                  const authors = getAuthorLinks(item);
                  return (
                    <li key={item.id}>
                      <Link to={getDetailLink(item)}>{item.title}</Link>
                      {item.definition ? (
                        <span className="latest-items__definition">
                          {" "}
                          — {item.definition}
                        </span>
                      ) : null}
                      {authors ? (
                        <span className="latest-items__authors">
                          {" "}
                          <span className="latest-items__authors-label">
                            Yazar:
                          </span>{" "}
                          {authors}
                        </span>
                      ) : null}
                    </li>
                  );
                })}
              </ul>
            </section>
          ))}
      </div>
    </Container>
  );
};

export default LatestItems;
